<template>
    <div class="flex float-left vertical-center">
        <vs-button v-bind:id="'btn-row-edit-'+rowNumber" size="small" icon-pack="feather" icon="icon-edit" @click="editRecord" color="success" class="mr-2"></vs-button>
        <vs-button v-bind:id="'btn-row-configure-'+rowNumber" size="small" icon-pack="feather" icon="icon-settings" @click="configureRecord" color="dark" class="mr-2"></vs-button>
    </div>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "ActionTableAgGridComponent",
        data() {
            return {
                isConfigure: false,
                rowNumber: 0
            }
        },
        methods: {
            editRecord() {
                this.$root.$emit("edit-from-ActionTableAgGridComponent", this.params.value)
            },
            configureRecord() {
                this.$root.$emit("configure-from-ActionTableAgGridComponent", this.params.value)
            }
        },
        created() {
            this.$root.$on("setConfigure-from-ActionTableAgGridComponent", (data) => {
                this.isConfigure = data["isConfigure"]
            })
            this.rowNumber = this.params.data.no
        }
    })
</script>

<style scoped>
    .vertical-center {
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
</style>